import React from "react";
import { required, SelectInput, useGetList, FormDataConsumer } from "react-admin";
import { Loading, Error } from "react-admin";

export const SelectInputCategory = () => {
  const { data, onLoading, error } = useGetList("categories");

  if (onLoading) return <Loading />;
  if (error) return <Error />;
  if (!data) return null;

  return (
    <FormDataConsumer>
      {({ formData, ...rest }) => {
        // Obtener el ID de la categoría actual (ya sea del formulario existente o seleccionada)
        const currentCategoryId = formData?.category?._id || formData?.category;

        // Encontrar la categoría seleccionada
        const selectedCategory = data.find((e) => e._id === currentCategoryId);
        let subcategories = [];
        if (selectedCategory) {
          subcategories = selectedCategory.subCategory || [];
        }

        return (
          <div>
            <SelectInput
              validate={[required()]}
              source="category"
              label="Categoría"
              choices={data
                .filter((e) => e.state)
                .map((e) => {
                  return { id: e._id, name: e.name };
                })}
              format={(v) => v?._id || v || ""}
              parse={(v) => data.find((cat) => cat._id === v)}
            />
            <br></br>
            <SelectInput
              validate={[required()]}
              label="SubCategoría"
              source="subCategory"
              choices={subcategories.map((e) => {
                return { id: e._id, name: e.name };
              })}
              format={(v) => v?._id || v || ""}
              parse={(v) => subcategories.find((subcat) => subcat._id === v)}
            />
          </div>
        );
      }}
    </FormDataConsumer>
  );
};
